import { ApiResponse } from '@/types';
import { CHECK_IN_LOGS_API_ENDPOINTS } from '@/constants';
import api from '@/services/api';

import { ICheckInLogDetails } from '@/features/check-in-logs/interfaces';

const CheckInLogDetailsService = {
  GetCheckInLogDetails: async (id: string): Promise<ApiResponse<ICheckInLogDetails>> => {
    const response = await api.get(
      CHECK_IN_LOGS_API_ENDPOINTS.CHECK_IN_LOGS_ID.replace(':logId', id),
    );
    return response.data;
  },
};

export default CheckInLogDetailsService;
